import { NewUserClinicianScreen } from "@/features/auth/screens/NewUserClinicianScreen";
import { newUserIndexRouteSearchSchema } from "@/features/auth/search/authRouteSearch";
import { createFileRoute } from "@tanstack/react-router";

const NewUserClinician = () => {
    const { email } = Route.useSearch();
    return <NewUserClinicianScreen email={email} />;
};

export const Route = createFileRoute("/_auth/new-user/clinician/")({
    component: NewUserClinician,
    validateSearch: (search) => newUserIndexRouteSearchSchema.parse(search ?? {}),
});
